import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Distribution_Approval.css';

const RENT_Distribution_Approval = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_DISTRIBUTION_APPROVAL",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_DISTRIBUTION_APPROVAL:-1
  });


  const [RENT_DISTRIBUTION_APPROVAL, setRENT_DISTRIBUTION_APPROVAL] = React.useState(null);
  const [RENT_DISTRIBUTION_APPROVAL_D, setRENT_DISTRIBUTION_APPROVAL_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Distribution Approval');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_DISTRIBUTION_APPROVAL(clientInfo,"OpenNew");

		navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_DISTRIBUTION_APPROVAL(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_DISTRIBUTION_APPROVAL(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_DISTRIBUTION_APPROVAL(clientInfo,"OpenNew");
		}
		navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_DISTRIBUTION_APPROVAL(Temp_Data2);
			navigate('/RENT_Distribution_Approval#New',{replace:true});
		} 
		else 
			navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Distribution_Approval',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_DISTRIBUTION_APPROVAL) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_DISTRIBUTION_APPROVAL]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_DISTRIBUTION_APPROVAL){
	  for(var Sec in RENT_DISTRIBUTION_APPROVAL[Ele]){
		if(Sec == "id")
			Ids.push(RENT_DISTRIBUTION_APPROVAL[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_DISTRIBUTION_APPROVAL[Ele]["status"]);
		else if(Array.isArray(RENT_DISTRIBUTION_APPROVAL[Ele][Sec]))
			  for(var Row in RENT_DISTRIBUTION_APPROVAL[Ele][Sec])  // Convert to RENT_DISTRIBUTION_APPROVAL[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_DISTRIBUTION_APPROVAL[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_DISTRIBUTION_APPROVAL"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_DISTRIBUTION_APPROVAL(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL`).then((response1) => {
		if(!RENT_DISTRIBUTION_APPROVAL) 
			setRENT_DISTRIBUTION_APPROVAL(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL_D`).then((response2) => {
			setRENT_DISTRIBUTION_APPROVAL_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_DISTRIBUTION_APPROVAL_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_DISTRIBUTION_APPROVAL = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_DISTRIBUTION_APPROVAL(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_DISTRIBUTION_APPROVAL = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_DISTRIBUTION_APPROVAL = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_DISTRIBUTION_APPROVAL = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_DISTRIBUTION_APPROVAL = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DISTRIBUTION_APPROVAL', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4"]=value;
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4",value,Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
  }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["1"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5"]=value;
	Form_Data_onChange("1","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5",value,Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
  }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["2"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("2","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["2"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("2","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["2"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("2","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["2"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("2","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["3"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("3","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["3"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("3","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["3"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("3","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0"]=value;
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
  }; 
  

    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["4"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("4","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["5"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("5","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  

const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
  }; 
  

    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  
    
const RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
	Temp_Data["9"]["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4"]=value;
	//handleAddRENT_DISTRIBUTION_APPROVAL(Temp_Data,App_Data['RENT_DISTRIBUTION_APPROVAL']);
	Form_Data_onChange("9","RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4",value,Temp_Data);
 	//handleLastDataRENT_DISTRIBUTION_APPROVAL(Temp_Data);
    setRENT_DISTRIBUTION_APPROVAL(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_DISTRIBUTION_APPROVAL) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedRENT_DISTRIBUTION_APPROVAL =JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
  updatedRENT_DISTRIBUTION_APPROVAL[Sec] = [...updatedRENT_DISTRIBUTION_APPROVAL[Sec], newRow];
  setRENT_DISTRIBUTION_APPROVAL(updatedRENT_DISTRIBUTION_APPROVAL);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_DISTRIBUTION_APPROVAL = JSON.parse(JSON.stringify(RENT_DISTRIBUTION_APPROVAL));
  updatedRENT_DISTRIBUTION_APPROVAL[sec].splice(index, 1);
  setRENT_DISTRIBUTION_APPROVAL(updatedRENT_DISTRIBUTION_APPROVAL);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Distribution Approval`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Distribution Approval ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Distribution Approval ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0" type="text" className="form-control" placeholder="RENT Distribution Approval ID" value={RENT_DISTRIBUTION_APPROVAL["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Distribution Approval ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Distribution ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1" type="text" className="form-control" placeholder="Distribution ID" value={RENT_DISTRIBUTION_APPROVAL["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Distribution ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2" type="text" className="form-control" placeholder="Offering ID" value={RENT_DISTRIBUTION_APPROVAL["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3" type="text" className="form-control" placeholder="Asset ID" value={RENT_DISTRIBUTION_APPROVAL["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Distribution Period Start`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4" type="date"  value={RENT_DISTRIBUTION_APPROVAL["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4`]} 
							onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4_Change} style={{ borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_4"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Distribution Period Start
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Distribution Period End`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5" type="date"  value={RENT_DISTRIBUTION_APPROVAL["1"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5`]} 
							onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5_Change} style={{ borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_1_5"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Distribution Period End
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Property Manager Report ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PM Report ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0" type="text" className="form-control" placeholder="PM Report ID" value={RENT_DISTRIBUTION_APPROVAL["2"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PM Report ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Rent Roll ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1" type="text" className="form-control" placeholder="Rent Roll ID" value={RENT_DISTRIBUTION_APPROVAL["2"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Rent Roll ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Record ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2" type="text" className="form-control" placeholder="Reserve Record ID" value={RENT_DISTRIBUTION_APPROVAL["2"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reserve Record ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bank Statement Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3" type="text" className="form-control" placeholder="Bank Statement Link" value={RENT_DISTRIBUTION_APPROVAL["2"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Bank Statement Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Calculated Distribution USD`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Calculated Distribution USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0" type="text" className="form-control" placeholder="Calculated Distribution USD" value={RENT_DISTRIBUTION_APPROVAL["3"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Calculated Distribution USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved Distribution USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1" type="text" className="form-control" placeholder="Approved Distribution USD" value={RENT_DISTRIBUTION_APPROVAL["3"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Approved Distribution USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Withheld Reserve USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2" type="text" className="form-control" placeholder="Withheld Reserve USD" value={RENT_DISTRIBUTION_APPROVAL["3"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Withheld Reserve USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Distribution Approval Decision`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Decision RENT`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0"  value={RENT_DISTRIBUTION_APPROVAL["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0`]} onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_0_Change} className="form-control" name="Approval Decision RENT"  >
						  <option value="Approve">Approve</option>
						  <option value="Approve With Reserve Holdback">Approve With Reserve Holdback</option>
						  <option value="Reject">Reject</option>
						  <option value="Request Revision">Request Revision</option>
						  <option value="Hold">Hold</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Decision RENT
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Compliance Reviewer ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1" type="text" className="form-control" placeholder="Compliance Reviewer ID" value={RENT_DISTRIBUTION_APPROVAL["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Compliance Reviewer ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Financial Reviewer ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2" type="text" className="form-control" placeholder="Financial Reviewer ID" value={RENT_DISTRIBUTION_APPROVAL["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Financial Reviewer ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3" type="text" className="form-control" placeholder="Approved By" value={RENT_DISTRIBUTION_APPROVAL["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Approved By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4" type="text" className="form-control" placeholder="Approved At" value={RENT_DISTRIBUTION_APPROVAL["4"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_4_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Approved At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Approval Notes`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0" type="text" className="form-control" placeholder="Approval Notes" value={RENT_DISTRIBUTION_APPROVAL["5"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0"  value={RENT_DISTRIBUTION_APPROVAL["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0`]} onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_DISTRIBUTION_APPROVAL["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_DISTRIBUTION_APPROVAL["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_DISTRIBUTION_APPROVAL["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_DISTRIBUTION_APPROVAL["9"][`RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4`]} 
						onChange={RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_05_FINANCE_ESCROW_DISTRIBUTION_REPORTING_RENT_DISTRIBUTION_APPROVAL_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Distribution_Approval;  